import { AUTH, USER } from "../../constants";
import axios from "@helpers/axios/public.axios";
import { getWallets, updateWalletEvent } from "@actions/wallet/changeWallet";

// Stores an issued session (user + token) and loads the wallets.
// Used after /login/verify and after /login when the backend skips the code step.
export const applyAuthResponse =
  ({ user, token }) =>
  async (dispatch) => {
    dispatch({
      type: AUTH.AUTH_RESPONSE,
      payload: {
        user,
        token,
        isDemoUser: false,
      },
    });

    dispatch({ type: USER.USER_RESPONSE, payload: { user } });

    await dispatch(getWallets());
    dispatch(updateWalletEvent());

    return {
      user,
      token,
    };
  };

export const loginVerify =
  ({ email, password, hash, verification }) =>
  async (dispatch) => {
    try {
      const response = await axios.post("/login/verify", {
        email,
        password,
        hash,
        code: verification,
      });

      return await dispatch(applyAuthResponse(response.data.data));
    } catch (e) {
      let message = "";
      if (e && e.response && e.response.data && e.response.data.message) {
        message = e.response.data.message;
      } else if (e && e.message) {
        message = e.message;
      }
      dispatch({ type: AUTH.AUTH_ERROR, payload: message });
      throw e;
    }
  };
